import { FC, JSX, ReactNode } from "react";
import { Text, View } from "react-native";
import Skeleton from "@/app/components/Skeleton";

export interface IStatItem {
  value?: string | number;
  info: string | number;
  isFullWidth?: boolean;
}

export interface IStatsBlockProps {
  stats?: IStatItem[];
  isLoading?: boolean;
}

const StatsBlock: FC<IStatsBlockProps> = ({ stats, isLoading }): JSX.Element => {
  const renderValueOrSkeleton = (value?: ReactNode) => {
    if (isLoading) return <Skeleton />;

    return <Text className="stats-header mb-1">{value ?? "Информация отсутствует"}</Text>
  };

  const renderStatsItems = (): JSX.Element[] =>
    stats?.map(({ info, value, isFullWidth }: IStatItem, i: number) => {

      return (
        <View
          key={i}
          className={`p-4 rounded-2xl bg-gray-100 ${
            isFullWidth ? "w-full mb-2" : "basis-44"
          }`}
        >
          {renderValueOrSkeleton(value)}
          <Text className="stats-text">{info}</Text>
        </View>
      );
    }) ?? [];

  return (
    <View className="flex flex-row flex-wrap gap-2">
      {renderStatsItems()}
    </View>
  );
};

export default StatsBlock;
